module.exports = __webpack_public_path__ + "media/smart_sales/benefit-1-568fead0.webp";